import * as React from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faLayerGroup,
    faEllipsis,
} from '@fortawesome/free-solid-svg-icons';

import { useWorkspaceContext } from "../context";



export default function LayerSelector() {
    const [isOpen, setOpen] = React.useState(false);
    const workspaceContext = useWorkspaceContext();
    // console.log("Workspace data", workspaceContext.data);
    return (
        <Dropdown
            isOpen={isOpen}
            toggle={() => setOpen(st => !st)}
            direction="down"
        >
            <DropdownToggle caret>
                <FontAwesomeIcon icon={faLayerGroup} />{" "}
                <span
                    style={{
                        // minWidth: 100,
                        // maxWidth: 200,
                        width: 150,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        margin: "inherit",
                        lineHeight: "1.3em",
                        height: "1em",
                    }}
                    className="text-start m-0 p-0"
                >
                    {"Some layer name"
                    || <span className="text-muted">Untitled workspace</span>}
                    {" "}
                </span>
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem>Layer 1</DropdownItem>
                <DropdownItem>Layer 2</DropdownItem>
                <DropdownItem>Layer 3</DropdownItem>
                <DropdownItem>Layer 4</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
}
